import { backendApi } from "./backend.api";
import { IUser } from "shared/models/models";
import { getSpaceId } from "shared/utils/space";

interface listQuery {
  opr?: boolean;
  inv?: boolean;
  spaceId?: number;
}

export const userApi = backendApi.injectEndpoints({
  endpoints: (build) => {
    return {
      users: build.query<IUser[], listQuery>({
        query: (queryParams) => {
          const spaceId = getSpaceId();
          const params: listQuery = { ...queryParams };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/user",
            method: "GET",
            params: params,
          };
        },
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: "User" as const, id })),
                "User",
              ]
            : ["User"],
      }),
      getUser: build.query<IUser, number>({
        query: (id) => ({ url: `/user/${id}`, method: "GET" }),
        transformErrorResponse: (response: { status: string | number }) =>
          response.status,
        providesTags: (item) => [{ type: "User", id: item?.id }],
      }),
      addUser: build.mutation<IUser, Partial<IUser>>({
        query: (payload) => {
          const spaceId = getSpaceId();
          const params: Partial<IUser> = { ...payload };
          if (spaceId) {
            params.spaceId = spaceId;
          }
          return {
            url: "/user",
            method: "POST",
            data: params,
          };
        },
        invalidatesTags: () => ["User"],
        transformResponse: (response: { data: IUser }) => response.data,
      }),
      updateUser: build.mutation<IUser, Partial<IUser>>({
        query: (payload) => ({
          url: `/user/${payload.id}`,
          method: "PATCH",
          data: payload,
        }),
        invalidatesTags: (item) => [{ type: "User", id: item?.id }],
        //transformResponse: (result, error) => [{ type: 'Visit', id: result?.id }],
      }),
      updateMultiUser: build.mutation<IUser[], IUser[]>({
        query: (payload) => ({
          url: "/user/update-multi",
          method: "POST",
          data: payload,
        }),
        invalidatesTags: (result = []) => [
          ...result.map(({ id }) => ({ type: "User", id: id }) as const),
        ],
        // transformResponse: (response: { data: IVisit[] }) => response.data,
      }),
      deleteUser: build.mutation<IUser, number>({
        query: (id) => ({
          url: `/user/${id}`,
          method: "DELETE",
          credentials: "include",
        }),
        invalidatesTags: ["User"],
      }),
    };
  },
});

export const {
  useUsersQuery,
  useGetUserQuery,
  useAddUserMutation,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useUpdateMultiUserMutation,
} = userApi;
